import { useNavigate } from "react-router-dom";
import StatusBadge from "./StatusBadge";
import { MessageSquare } from "lucide-react";

const OrderCard = ({ order, getOrderStatus }) => {
  const navigate = useNavigate();
  const status = getOrderStatus(order);

  return (
    <div
      onClick={() => navigate(`/order/preview/${order._id}`)}
      className="bg-white border border-gray-200 rounded-xl px-4 py-4 flex justify-between items-start hover:shadow-md transition cursor-pointer"
    >
      {/* LEFT */}
      <div className="flex flex-col gap-2 flex-1 min-w-0">
        {/* HEADER */}
        <div className="flex items-center justify-between">
          <p className="font-semibold text-base text-gray-900 tracking-tight">
            Order #{order._id.slice(-4)}
          </p>

          <p className="text-xs text-gray-400">
            {new Date(order.createdAt).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </p>
        </div>

        {/* CUSTOMER */}
        <p className="text-sm text-gray-700">
          <span className="font-medium">
            {order.customer_info?.firstname || "Guest"}
          </span>
          <span className="text-gray-400"> • </span>
          <span>{order.orderItems.length} items</span>
        </p>

        {/* META */}
        <div className="flex items-center gap-2 flex-wrap mt-2 mb-2">
          <StatusBadge status={status} />

          {order.payments?.paymentStatus === "paid" && (
            <span className="text-xs px-2 py-1 rounded-md bg-green-100 text-green-700 font-medium">
              Paid
            </span>
          )}

          {order.payments?.paymentStatus === "refunded" && (
            <span className="inline-flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full bg-red-100 text-red-600 font-semibold border border-red-200">
              {/* animated dot */}
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>

                <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
              </span>
              Refunded
            </span>
          )}

          <span className="text-xs px-2 py-1 rounded-md bg-gray-100 text-gray-600 capitalize">
            {order.payments?.paymentMethod}
          </span>

          <span className="text-xs px-2 py-1 rounded-md bg-gray-50 text-gray-500 border">
            Pickup
          </span>
        </div>

        {/* NOTE */}
        {order.customer_info?.message && (
          <div className="flex items-start gap-2 bg-amber-50 border border-amber-200 px-3 py-2 rounded-md ">
            <MessageSquare size={16} className="text-amber-500 mt-[2px]" />
            <p className="text-sm text-amber-800 leading-relaxed">
              {order.customer_info.message}
            </p>
          </div>
        )}
      </div>

      {/* RIGHT */}
      <div className="text-right ml-4 flex flex-col items-end justify-between h-full">
        <p className="font-semibold text-base text-gray-900">
          ${order.totalPrice.toFixed(2)}
        </p>

        {order.orderStatus === "cancelled" &&
          order.payments?.paymentStatus === "paid" && (
            <button
              onClick={() => navigate(`/order/preview/${order._id}`)}
              // disabled={refundLoading}
              className="text-xs px-3 py-1 flex items-center gap-2 flex-wrap mt-2 mb-2 rounded-full bg-red-100 text-red-500 hover:bg-red-600 hover:text-white transition disabled:opacity-50"
            >
              Refund Available
            </button>
          )}
      </div>
    </div>
  );
};

export default OrderCard;
